import { render, staticRenderFns } from "./bulma_table_writeinline.vue?vue&type=template&id=2e863f73&scoped=true&lang=html"
import script from "./bulma_table_writeinline.vue?vue&type=script&lang=js"
export * from "./bulma_table_writeinline.vue?vue&type=script&lang=js"
import style0 from "./bulma_table_writeinline.vue?vue&type=style&index=0&id=2e863f73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e863f73",
  null
  
)

export default component.exports